import { useRef, useState } from "react";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";

export default function CinematicVideo() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <section
      id="cinematic"
      data-testid="cinematic-video-section"
      className="bg-brand-bg py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-20">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <p className="overline">Een gevoel</p>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-brand-ink sm:text-5xl lg:text-6xl text-balance">
              De sfeer van <span className="italic">de straat</span>.
            </h2>
            <p className="mt-6 max-w-xl text-lg text-brand-muted">
              Een doorsnee voorjaarsmiddag in de Kempenaar — rustig, groen en kindvriendelijk.
            </p>
          </div>
        </div>

        <div className="relative overflow-hidden border border-brand-border bg-black">
          <video
            ref={videoRef}
            data-testid="cinematic-video"
            autoPlay
            loop
            muted
            playsInline
            poster="https://cloud.funda.nl/valentina_media/230/008/690.jpg?options=width=2160"
            className="block w-full aspect-video object-cover"
          >
            <source src="/videos/kempenaar29_v1.mp4" type="video/mp4" />
          </video>

          {/* Controls overlay */}
          <div className="absolute bottom-4 right-4 flex gap-2">
            <button
              data-testid="cinematic-play-toggle"
              onClick={togglePlay}
              aria-label={playing ? "Pauzeer video" : "Speel video"}
              className="flex h-10 w-10 items-center justify-center bg-black/50 text-white backdrop-blur-md transition-colors hover:bg-black/70"
            >
              {playing ? <Pause size={16} /> : <Play size={16} fill="currentColor" />}
            </button>
            <button
              data-testid="cinematic-mute-toggle"
              onClick={toggleMute}
              aria-label={muted ? "Geluid aan" : "Geluid uit"}
              className="flex h-10 w-10 items-center justify-center bg-black/50 text-white backdrop-blur-md transition-colors hover:bg-black/70"
            >
              {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
            </button>
          </div>

          <div className="absolute bottom-4 left-4 inline-flex items-center gap-2 bg-black/50 px-3 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-white backdrop-blur-md">
            Sfeerbeeld · loops
          </div>
        </div>

        <p className="mt-4 text-xs text-brand-muted">
          Sfeerbeeld ter illustratie · Plan een bezichtiging om de Kempenaar zelf te ervaren.
        </p>
      </div>
    </section>
  );
}
